import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, CircularProgress, TextField } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { saveAs } from 'file-saver'
import { getFileContainer } from 'container/file-module'
import { FileService } from 'modules/files/services/FileService'
import { FILE_SERVICE_KEY } from 'modules/files'
import { COLOR_PRIMARY } from '../../routes/color-constants'
import { useStyles } from '../matchings/Matching.styles'

const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)

export const DownloadKits = () => {
    const { t } = useTranslation()
    const classes = useStyles({ color: COLOR_PRIMARY })
    const { enqueueSnackbar } = useSnackbar()

    const [code, setCode] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const handleDownload = () => {
        const wanted = code.trim()
        if (!wanted) {
            enqueueSnackbar(t('kitCodeRequired'), { variant: 'error' })
            return
        }

        setIsLoading(true)
        fileService.getKitByCode(wanted).subscribe((kit) => {
            setIsLoading(false)

            if (!kit) {
                enqueueSnackbar(t('kitNotFound'), { variant: 'error' })
                return
            }

            fileService.downloadKit(kit.id).then((res) => {
                if (!res) {
                    enqueueSnackbar(t('kitDownloadError'), { variant: 'error' })
                    return
                }
                saveAs(res.blob, kit.zipName)
            })
        })
    }

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault()
                handleDownload()
            }}>
            <Box display={'flex'} alignItems={'flex-start'} mb={2}>
                <TextField
                    autoFocus
                    fullWidth
                    id={'kitCode'}
                    type={'text'}
                    label={t('kitCode')}
                    variant={'outlined'}
                    InputLabelProps={{ shrink: true }}
                    value={code}
                    disabled={isLoading}
                    onChange={(e) => setCode(e.target.value)}
                />
                <Box ml={2} display={'flex'} alignItems={'flex-start'}>
                    <Button
                        className={classes.button}
                        variant={'contained'}
                        type={'submit'}
                        disabled={isLoading}
                        style={{ height: '56px' }}>
                        {isLoading ? <CircularProgress size={20} /> : t('download2')}
                    </Button>
                </Box>
            </Box>
        </form>
    )
}